import React, { useState } from 'react';
import { useRouter } from 'next/router';
import Geocode from 'react-geocode';
import Cookie from 'cookie';
import { useSelector, useDispatch } from 'react-redux';
import { reqLocationsAction } from '@stores/locations/actions';

import { NEXT_PUBLIC_GOOGLE_MAPS_KEY } from '@/app-configuration';
import { Modal, Button } from '@components';

import styles from './PostalCodeModal.module.scss';

export default function PostalCodeModal(pageProps) {
  const [postalCode, setPostalCode] = useState('');
  const { locale } = useRouter();
  const { showPostalModal, setShowPostalModal, updatePostalCode } = pageProps;
  const dispatch = useDispatch();

  const submitClicked = () => {
    $('#postalCodeFeedback').hide();

    const validatePostalCode = (code) => {
      var regEx = /^[a-zA-Z][0-9][a-zA-Z](-| |)[0-9][a-zA-Z][0-9]$/;
      return regEx.test(code);
    }

    const code = postalCode.trim().toUpperCase().replace(/\s/g, '');

    if (validatePostalCode(code)) {
      const updateLocation = async () => {
        const { province, formattedPostalCode, lngLat } = await getProvince(code);

        if (province) {
          const setCookie = (key, value) => {
            document.cookie = Cookie.serialize(key, value, {
              path: '/',
              maxAge: 60 * 60 * 24 * 7
            });
          };
          setCookie('postalCode', String(formattedPostalCode));
          setCookie('province', String(province));
          setCookie('lngLat', String(`${lngLat.lng} ${lngLat.lat}`));

          // Temporary fix
          window.location.reload();
          return;

          if (window.build) window.build.SBDisp?.HandleInitialLoad();

          setShowPostalModal(false);

          if (updatePostalCode) {
            updatePostalCode({
              postalCode: String(formattedPostalCode),
              province: String(province),
              lngLat: String(lngLat)
            });
          }
        } else {
          $('#postalCodeFeedback').html(locale == 'fr' ? 'Code postal invalide.' : 'Invalid postal code.');
          $('#postalCodeFeedback').show();
        }
      };
      updateLocation();
    } else {
      $('#postalCodeFeedback').html(locale == 'fr' ? 'Code postal invalide.' : 'Invalid postal code.');
      $('#postalCodeFeedback').show();
    }
  };

  const cancelClicked = () => {
    setShowPostalModal(false);
    history.back();
  };

  return (
    <Modal
      show={showPostalModal}
      className={styles.postalCodeModal}
      onHide={() => setShowPostalModal(false)}
    >
      <img className={styles.logo} src="/assets/logos/kubota-logo-wide.png" />
      <h3>{locale == 'fr' ? 'Construire et obtenir un devis' : 'Build & Quote'}</h3>
      <div className={styles.title}>
        {locale == 'fr' ? 'Veuillez indiquer votre code postal' : 'We need your postal code'}
      </div>
      <div className={styles.postalCodeField}>
        <input
          type="text"
          placeholder="V7L 2Y2"
          name="modalPostalCode"
          value={postalCode}
          onChange={e => setPostalCode(e.target.value)}
        />
      </div>
      <div id="postalCodeFeedback" className={styles.feedback}></div>
      <div className={styles.buttons}>
        <Button onClick={submitClicked} >
          {locale == 'fr' ? 'Commencer': 'Begin'}
        </Button>
        <Button onClick={cancelClicked} className={styles.btn_cancel}>
          {locale == 'fr' ? 'Annuler': 'Cancel'}
        </Button>
      </div>
    </Modal>
  );
}


export async function getProvince(postalCode) {
  let province = '';
  let formattedPostalCode = '';
  let lngLat = '';

  Geocode.setApiKey(NEXT_PUBLIC_GOOGLE_MAPS_KEY);
  Geocode.setLanguage('en');
  // Geocode.enableDebug();

  try {
    const response = await Geocode.fromAddress(postalCode);

    const result = response.results.find(res => res.formatted_address.includes('Canada'));
    if (result) {
      const { address_components, geometry } = result;

      lngLat = geometry.location;

      province = address_components.reduce((prevValue, currValue) => {
        if (currValue.types.includes('administrative_area_level_1')) {
          return currValue.short_name;
        }
        return prevValue;
      }, null);

      formattedPostalCode = address_components.reduce((prevValue, currValue) => {
        if (currValue.types.includes('postal_code')) {
          return currValue.long_name;
        }
        return prevValue;
      }, null);
    }
  } catch (error) {
    console.error(error);
  }

  return { province, formattedPostalCode, lngLat };
}
